<mat-nav-list class="help-center">
  <!-- <div class="flex align-center justify-space-between my-1 px-2 pt-2">
    <div class="flex align-center">
      <app-icon class="text-400" size="xs" name="bold-message-question"></app-icon>
      <span class="help-center__list-item m-2">{{ 'shared.HelpCenter' | translate}}</span>
    </div>
  </div> -->
  <app-nav-list [menuList]="navigationItems" color="basic" [divider]="true" (action)="navService.action$.next($event)"></app-nav-list>
</mat-nav-list>
